<template>
<transition name="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container cont2">


        <b-row class=" no-gutters">
          
          <div class="heading">
            Thank you,<br>
your email has been sent!
          </div>
          
          <div class="continue-btn" @click="closeDiscussions">CONTINUE</div>
        </b-row>
    
      </div>
    </div>
  </div>
</transition>

</template>
<script>
/* eslint-disable */
 
  import scrollMixin from '../mixins/scrollMixin';
  import { mapGetters, mapMutations } from 'vuex';
  
export default {
  name: "modalImpDisc",
  components: {
    },
  mixins: [scrollMixin],
   mounted: function() {
      this.scrollToTop();
    },
  
  data() {
    return {
     
    };
  },
  
  computed: {
      ...mapGetters('userData', ['userData']),
  },
  
  created() {

    
  },
    
  methods: {
     ...mapMutations('userData', ['saveUserData']),
        closeDiscussions: function() {
   this.userData.isEmailSent = false;
        this.$router.go(-1);
    },

}
};
</script>

<style lang="scss" scoped>
  
</style>
